<div class="page-module">

    <div fxLayout="row" fxLayoutAlign="space-around center">
        <img src="../../assets/img/logo_procesa.png">
    </div>

    <br>
    <br>
    <div class="title-box" fxLayout="row" fxLayoutAlign="space-around center">
        <!-- <mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="space-around center"> -->
            <h1>SELECCIONE EL MÓDULO </h1>
        <!-- </mat-toolbar> -->

    </div>

    <br>

    <!-- <div class="view-mode-container"> -->
    <div class="view-mode-container">
        <div class="view-mode">
            <button mat-raised-button [color]="viewModeActive === 'grilla' ? 'primary': undefined"
                (click)="toggleMode('grilla')">
                <mat-icon>grid_view</mat-icon>Grilla
            </button>
            <button mat-raised-button [color]="viewModeActive === 'lista' ? 'primary': undefined"
                (click)="toggleMode('lista')">
                <mat-icon>list</mat-icon> Lista
            </button>
            <!-- <mat-button>Grilla</mat-button>
            <mat-button>Lista</mat-button> -->
        </div>
    </div>

    <div
        [ngClass]="{'contenedor-grid': viewModeActive === 'grilla',
                'contenedor-lista': viewModeActive === 'lista'}">
        <modulo-card-item *ngFor="let modulo of list"
            #modulocard
            [modulo]="modulo"
            [viewMode]="viewModeActive"
            (dirigirirAlModulo)="goModule($event, modulocard)"
        ></modulo-card-item>
    </div>
    
</div>
